import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const withUser = (WrappedComponent) => {
  class UserCheckerUnwrapped extends Component {
    render() {
      return (<WrappedComponent {...this.props} />);
    }
  }

  UserCheckerUnwrapped.propTypes = {
    user: ImmutablePropTypes.map.isRequired,
    authorities: ImmutablePropTypes.list.isRequired,
  };

  const mapStateToProps = state => ({
    user: state.getIn(['loginPage', 'user']),
    authorities: state.getIn(['loginPage', 'user', 'authorities']),
  });

  return connect(mapStateToProps, null)(UserCheckerUnwrapped);
};
